import {
  InfoItem,
  InfoItemProps,
} from 'components/molecules/InfoItem/InfoItem';
import styles from './InfoItemGroup.module.scss';

type InfoItemGroupProps = {
  items: InfoItemProps[];
};

const InfoItemGroup = ({ items }: InfoItemGroupProps) => {
  return (
    <div className={styles.container}>
      {items.map(item => (
        <InfoItem
          key={item.label}
          label={item.label}
          value={item.value}
          hasCopyButton={item.hasCopyButton}
          hasCopyButtonTooltip={item.hasCopyButtonTooltip}
          maxWidth={item.maxWidth}
        />
      ))}
    </div>
  );
};

export default InfoItemGroup;
